export default {
	name: 'school-finance',
	path: '/school-finance',
	meta: {
		title: '财务中心'
	},
	redirect: '/school-finance/payment',
	children: [
		{
			name: 'finance-payment',
			path: 'payment',
			fullPath: '/school-finance/payment',
			meta: {
				// title: '校园缴费'
			},
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/payment')
		},
		{
			name: 'finance-consumption',
			path: 'consumption',
			fullPath: '/school-finance/consumption',
			redirect: '/school-finance/consumption/statistics',
			meta: {
				title: '消费系统',
				icon: 'icon-consumption'
			},
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/consumption'),
			children: [
				{
					name: 'consumption-staff-statistics',
					path: 'staff-statistics',
					fullPath: '/school-finance/consumption/staff-statistics',
					meta: {
						// title: '职工消费系统',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/staff-statistics')
				},
				{
					name: 'consumption-user-info',
					path: 'user-info',
					fullPath: '/school-finance/consumption/user-info',
					meta: {
						// title: '用户信息',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/user-info')
				},
				{
					name: 'consumption-flow-record',
					path: 'flow-record',
					fullPath: '/school-finance/consumption/flow-record',
					meta: {
						// title: '流水记录',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/flow-record')
				},
				{
					name: 'consumption-refund-record',
					path: 'refund-record',
					fullPath: '/school-finance/consumption/refund-record',
					meta: {
						title: '退款记录',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/refund-record')
				},
				{
					name: 'consumption-manual-charge',
					path: 'manual-charge',
					fullPath: '/school-finance/consumption/manual-charge',
					meta: {
						// title: '充值管理',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/manual-charge')
				},
				{
					name: 'consumption-offline-info',
					path: 'offline-info',
					fullPath: '/school-finance/consumption/offline-info',
					meta: {
						// title: '设备管理',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/offline-info')
				},
				{
					name: 'consumption-business',
					path: 'business',
					fullPath: '/school-finance/consumption/business',
					meta: {
						// title: '商户管理',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/business')
				},
				{
					name: 'consumption-error-report',
					path: 'error-report',
					fullPath: '/school-finance/consumption/error-report',
					meta: {
						// title: '错误报告',
						icon: 'icon-consumption-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/consumption/error-report')
				}
			]
		},
		{
			name: 'face-payment',
			path: '/face-payment',
			redirect: '/statistical-report',
			meta: {
				title: '人脸支付'
			},
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/face-payment'),
			children: [
				{
					name: 'statistical-report',
					path: '/statistical-report',
					meta: {
						title: '统计报表'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/statistics-report')
				},
				{
					name: 'face-payment-user-info',
					path: '/face-payment-user-info',
					meta: {
						title: '用户信息'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/user-info')
				},
				{
					name: 'face-payment-recharge-manage',
					path: '/face-payment-recharge-manage',
					meta: {
						title: '充值管理'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/recharge-manage')
				},
				{
					name: 'face-payment-batch-recharge',
					path: '/face-payment-batch-recharge',
					meta: {
						title: '任意金额批量充值/消费'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/recharge-manage/batchRecharge')
				},
				{
					name: 'face-payment-flow-record',
					path: '/face-payment-flow-record',
					meta: {
						// title: '流水记录',
						icon: 'icon-face-payment-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/flow-record')
				},
				{
					name: 'face-payment-offline-info',
					path: '/face-payment-offline-info',
					meta: {
						// title: '设备管理',
						icon: 'icon-face-payment-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/offline-info')
				},
				{
					name: 'face-payment-business',
					path: '/face-payment-business',
					meta: {
						// title: '商户管理',
						icon: 'icon-face-payment-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/business')
				},
				{
					name: 'face-payment-refund-record',
					path: '/face-payment-refund-record',
					meta: {
						title: '退款记录',
						icon: 'icon-face-payment-statistics'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/refund-record')
				},
				{
					name: '/face-payment-dining-statistics',
					path: '/face-payment-dining-statistics',
					meta: {
						title: '就餐统计'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/dining-statistics')
				},

				{
					name: 'dining-record',
					path: 'dining-record',
					fullPath: '/face-payment/dining-record',
					meta: {
						title: '就餐记录',
						icon: 'icon-consumption-dining-record'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/dining-record')
				},
				{
					name: 'set-meal',
					path: 'set-meal',
					fullPath: '/face-payment/set-meal',
					meta: {
						title: '套餐设置',
						icon: 'icon-consumption-set-meal'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/set-meal')
				},
				{
					name: 'package-content',
					path: 'package-content',
					fullPath: '/face-payment/set-meal/package-content',
					meta: {
						// title: '设置套餐内容'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/set-meal/package-content')
				},
				{
					name: 'modify-ordering',
					path: 'modify-ordering',
					fullPath: '/face-payment/set-meal/modify-ordering',
					meta: {
						// title: '修改订餐人'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/set-meal/modify-ordering')
				},
				{
					name: 'bulk-ordering',
					path: 'bulk-ordering',
					fullPath: '/face-payment/set-meal/bulk-ordering',
					meta: {
						// title: '批量订餐'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/set-meal/bulk-ordering')
				},
				{
					name: 'card-management',
					path: '/card-management',
					fullPath: '/face-payment/card-management',
					meta: {
						// title: '卡管理'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/card-management')
				},
				{
					name: '/face-payment-id-card-management',
					path: '/face-payment-id-card-management',
					meta: {
						title: '号码管理'
					},
					component: () =>
						import(/*webpackChunkName: "school-finance"*/ '@/views/school-finance/face-payment/id-card-management')
				}
			]
		},
		{
			name: 'finance-subscribe',
			path: 'subscribe',
			fullPath: '/school-finance/subscribe',
			redirect: '/school-finance/subscribe/agent-account',
			meta: {
				title: '中小学服务订阅'
			},
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/subscribe'),
			children: [
				{
					name: 'subscribe-agent-account',
					path: 'agent-account',
					fullPath: '/school-finance/subscribe/agent-account',
					meta: {
						// title: '代理商账号管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/subscribe/agent-account')
				},
				{
					name: 'subscribe-service-management',
					path: 'service-management',
					fullPath: '/school-finance/subscribe/service-management',
					meta: {
						// title: '服务管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/subscribe/service-management')
				},
				{
					name: 'subscribe-order-list',
					path: 'order-list',
					fullPath: '/school-finance/subscribe/order-list',
					meta: {
						// title: '交易订单'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/subscribe/order-list')
				},
				{
					name: 'subscribe-data-static',
					path: 'data-static',
					fullPath: '/school-finance/subscribe/data-static',
					meta: {
						// title: '数据统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/subscribe/data-static')
				}
			]
		},
		{
			name: 'face-charging-system',
			path: '/face-charging-system',
			meta: {
				title: '人脸收费系统'
			},
			redirect: '/school-finance/face-charges/face-access-management',
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/face-charges'),
			children: [
				{
					name: 'face-access-management',
					path: '/school-finance/face-charges/face-access-management',
					// meta: {
					// 	title: '人脸权限管理'
					// },
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/face-charges/face-access-management')
				},
				{
					// new-record-of-face-permissions
					name: 'face-permissions',
					path: '/school-finance/face-charges/face-permissions',
					meta: {
						title: '人脸权限购买记录'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/face-charges/face-permissions')
				},
				{
					// Unsubscribe/recycle records
					name: 'recycle-records',
					path: '/school-finance/face-charges/recycle-records',
					meta: {
						title: '退订/回收记录'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/face-charges/recycle-records')
				}
			]
		},
		{
			name: 'family-phone',
			path: 'family-phone',
			meta: {
				title: '亲情电话'
			},
			fullPath: '/school-finance/family-phone',
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/family-phone')
		},
		{
			name: 'new-payment',
			path: '/new-payment',
			meta: {
				title: '校园缴费'
			},
			redirect: '/school-finance/new-payment',
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment'),
			children: [
				{
					name: 'chargeItems',
					path: '/school-finance/new-payment/chargeItems',
					meta: {
						title: '名单收费'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment/chargeItems')
				},
				{
					name: 'chargeDetails',
					path: '/school-finance/new-payment/chargeDetails',
					meta: {
						// title: '费用明细'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment/chargeDetails')
				},
				{
					name: 'createCharge',
					path: '/school-finance/new-payment/createCharge',
					meta: {
						// title: '创建账单'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment/createCharge')
				},
				{
					name: 'schoolMerchantAllocation',
					path: '/school-finance/new-payment/school-merchant-allocation',
					meta: {
						title: '学校商户配置'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment/school-merchant-allocation')
				},
				{
					name: 'code-payment',
					path: '/school-finance/new-payment/code-payment',
					meta: {
						// title: '二维码收费'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment/code-payment')
				},
				{
					name: 'createCode',
					path: '/school-finance/new-payment/createCode',
					meta: {
						// title: '创建二维码'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment/createCode')
				},
				{
					name: 'codeDetail',
					path: '/school-finance/new-payment/codeDetail',
					meta: {
						// title: '二维码明细'
					},
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/school-finance/new-payment/codeDetail')
				}
			]
		}
	]
};
